import React, { Component } from 'react';
import { Box, Button, Typography } from '@mui/material';

import StyledModal from '../../styles/StyledModal';
import { STATUS_LABELS } from './constants';

interface FundStatusWorkflowProps {
  fundOpportunity: any;
  open: boolean;
  action?: string;
  investor?: any;
  amount?: number;
  onClose: () => void;
  onConfirm: () => void;
}

class FundStatusWorkflow extends Component<FundStatusWorkflowProps> {
  requiresFundStatusConfirmation = (fundStatus: string): boolean => {
    return fundStatus === 'UNDER_MANAGEMENT' || fundStatus === 'COMPLETE';
  };

  getFundStatusWarningMessage = (action: string, fundStatus: string): string => {
    const statusText = fundStatus === 'UNDER_MANAGEMENT' ? 'under management' : 'completed';
    return `This fund is currently ${statusText}. Are you sure you want to proceed with "${action}"? This action may affect fund calculations and reporting.`;
  };

  render() {
    const { open, action, investor, amount, fundOpportunity, onClose, onConfirm } = this.props;

    if (!open || !action || !investor) {
      return null;
    }

    const fundStatus = fundOpportunity.status;
    const warningMessage = this.getFundStatusWarningMessage(action, fundStatus);

    return (
      <StyledModal
        open={open}
        onClose={onClose}
        title={`Confirm ${action}`}
        actions={
          <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
            <Button variant="outlined" onClick={onClose}>
              Cancel
            </Button>
            <Button variant="contained" color="warning" onClick={onConfirm}>
              Proceed
            </Button>
          </Box>
        }
      >
        <Typography variant="body1" sx={{ mb: 2 }}>
          {warningMessage}
        </Typography>

        <Box
          sx={{
            backgroundColor: '#fff3cd',
            border: '1px solid #ffeaa7',
            borderRadius: 1,
            p: 2,
            mb: 2,
          }}
        >
          <Typography variant="body2" sx={{ fontWeight: 600, mb: 1 }}>
            Action Details:
          </Typography>
          <Typography variant="body2">
            <strong>Investor:</strong> {investor.contact?.name || 'Unknown'}
            <br />
            <strong>Action:</strong> {action}
            {amount && (
              <>
                <br />
                <strong>Amount:</strong> ${amount.toLocaleString()}
              </>
            )}
            <br />
            <strong>Fund Status:</strong> {STATUS_LABELS[fundStatus] || fundStatus}
          </Typography>
        </Box>

        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          Do you want to proceed with this action?
        </Typography>
      </StyledModal>
    );
  }
}

export default FundStatusWorkflow;
